namespace $ { $mol_style_attach( "mol/text/demo/demo.view.css",
 "[mol_text_demo_view_page] {\n\tflex: 1 0 40rem;\n}\n\n[mol_text_demo_code_page] {\n\tflex: 0 0 40rem;\n}\n\n[mol_text_demo_view_page_body],\n[mol_text_demo_code_page_body] {\n\tpadding: var(--mol_gap_block);\n}\n"
) }